// These default chart options are used as the base for all reporting visualizations.

import { ColorSeries, getChartThemeColors } from './Colors';
export default (theme => {
  const colors = getChartThemeColors(theme);
  return {
    chart: {
      animation: false,
      reflow: false,
      // avoid extra work since reflow will be handled by our component using ResizeObserver
      style: {
        fontFamily: 'inherit'
      }
    },
    colors: ColorSeries.DEFAULT,
    title: {
      text: ''
    },
    plotOptions: {
      series: {
        animation: false,
        dataLabels: {
          color: colors.TEXT_COLOR,
          style: {
            fontWeight: '600'
          }
        }
      }
    },
    xAxis: {
      lineColor: colors.LINE_COLOR_DARK,
      lineWidth: 1,
      gridLineColor: colors.LINE_COLOR,
      tickColor: colors.LINE_COLOR_DARK,
      tickPosition: 'inside',
      tickLength: 5,
      labels: {
        style: {
          color: colors.TEXT_COLOR
        }
      },
      stackLabels: {
        style: {
          color: colors.TEXT_COLOR
        }
      },
      title: {
        text: null,
        style: {
          color: colors.TEXT_COLOR,
          fontWeight: '600'
        }
      }
    },
    yAxis: {
      lineColor: 'transparent',
      lineWidth: 1,
      gridLineColor: colors.BATTLESHIP_TRANSPARENT,
      gridLineDashStyle: 'ShortDash',
      tickColor: colors.LINE_COLOR_DARK,
      tickPosition: 'inside',
      tickLength: 5,
      labels: {
        style: {
          color: colors.TEXT_COLOR
        }
      },
      stackLabels: {
        style: {
          color: colors.TEXT_COLOR
        }
      },
      title: {
        text: null,
        style: {
          color: colors.TEXT_COLOR
        }
      }
    },
    legend: {
      enabled: true,
      borderWidth: 0,
      symbolRadius: 4,
      symbolWidth: 8,
      symbolHeight: 8,
      itemMarginBottom: 4,
      align: 'left',
      verticalAlign: 'top',
      maxHeight: 40,
      y: -8,
      margin: 20,
      itemStyle: {
        color: colors.TEXT_COLOR,
        fontSize: '12px',
        fontWeight: '600',
        textDecoration: 'none'
      },
      navigation: {
        activeColor: colors.TEXT_COLOR,
        inactiveColor: colors.TEXT_INACTIVE,
        style: {
          color: colors.TEXT_COLOR,
          fontSize: '12px'
        }
      }
    },
    tooltip: {
      backgroundColor: colors.TOOLTIP_BACKGROUND_COLOR
    },
    credits: {
      enabled: false
    }
  };
});